import { getDocuments } from '../services/documents';

const getLogs = async (): Promise<any> => {
  const data: any = await getDocuments('log');
  return data;
};

const downloadTodayLogs = async ({
  tenant,
  dateFrom,
  dateTo,
}): Promise<any> => {
  const data = await getDocuments(
    `log/download?tenant=${tenant}&dateFrom=${dateFrom}&dateTo=${dateTo}`,
  );

  return data;
};

export { getLogs, downloadTodayLogs };
